var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Test"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M16.7917 17.7679C16.7917 18.0773 16.6688 18.3741 16.45 18.5929C16.2312 18.8117 15.9344 18.9346 15.625 18.9346H2.79167C2.48225 18.9346 2.1855 18.8117 1.96671 18.5929C1.74792 18.3741 1.625 18.0773 1.625 17.7679V2.60124C1.625 2.29182 1.74792 1.99507 1.96671 1.77628C2.1855 1.55749 2.48225 1.43457 2.79167 1.43457H11.0587C11.3679 1.43464 11.6644 1.55745 11.8831 1.77601L16.4502 6.34313C16.6688 6.56184 16.7916 6.85837 16.7917 7.16757V17.7679Z",
    stroke: "#878E95",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    d: "M7.9785 6.90039L6.32028 9.11083C6.27012 9.17764 6.20619 9.23288 6.13282 9.27284C6.05945 9.31279 5.97836 9.33652 5.89503 9.34242C5.8117 9.34832 5.72807 9.33625 5.64981 9.30703C5.57154 9.27781 5.50047 9.23212 5.44139 9.17306L4.5415 8.27395",
    stroke: "#878E95",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    d: "M7.9785 12.1504L6.32028 14.3608C6.27012 14.4276 6.20619 14.4829 6.13282 14.5228C6.05945 14.5628 5.97836 14.5865 5.89503 14.5924C5.8117 14.5983 5.72807 14.5863 5.64981 14.557C5.57154 14.5278 5.50047 14.4821 5.44139 14.4231L4.5415 13.5232",
    stroke: "#878E95",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_4",
    d: "M10.375 9.34473H13.875",
    stroke: "#878E95",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_5",
    d: "M10.375 14.0107H13.875",
    stroke: "#878E95",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/test.761bcd84.svg";
export { ForwardRef as ReactComponent };